export default __webpack_public_path__ + "9d81ddef4313f01f7b022bffaa76a3d7.png";